import React, { useState } from "react";

import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/LocalHospitalOutlined";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core";

import Breakpoints from "common/breakpoints";
import AddHorseToTrackPopup from "pages/HorseListPage/HorseActionsMenu/AddHorseToTrackPopup";
import { MuiTheme } from "theme";

import useStyles from "./styles";

const AddHorseToTrack = () => {
  const classes = useStyles();
  const theme = useTheme<MuiTheme>();
  const matchesDownSm = useMediaQuery(
    theme.breakpoints.down(Breakpoints.SX_720),
    {
      noSsr: true
    }
  );

  const [isAddHorsePopupOpen, setIsAddHorsePopupOpen] = useState(false);

  const handleOpenPopup = () => {
    setIsAddHorsePopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsAddHorsePopupOpen(false);
  };

  const buttonTitle = matchesDownSm ? "Add Horse" : "Add Horse To A Track";

  return (
    <>
      <Button
        className={classes.addHorseButton}
        startIcon={<AddIcon />}
        onClick={handleOpenPopup}
      >
        {buttonTitle}
      </Button>

      {isAddHorsePopupOpen && (
        <AddHorseToTrackPopup open={true} onClose={handleClosePopup} />
      )}
    </>
  );
};

export default React.memo(AddHorseToTrack);
